import { regular } from '@/utils/regular';

export default {
  props: {
    company_dv: {
      type: Boolean,
      default: false,
    },
    companyForm: {
      type: Object,
      default() {
        return {};
      },
    },
    titleType: {
      type: String,
      default: 'new',
    },
    envName: {
      type: String,
      default: 'master',
    },
    envType: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    company_dv(val) {
      this.company_dialog = val;
    },
    companyForm: {
      handler(newValue) {
        this.companyFormObj = newValue;
      },
      deep: true,
    },
  },
  data() {
    const checkEntityName = (rule, value, callback) => {
      console.log(value)
      const reg = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5\(\)\（\）]/g; //eslint-disable-line
      if (reg.test(value)) {
        return  callback(new Error('主体名称仅支持中、英文、数字及()'));
      } else {
        return callback();
      }
    }
    return {
      checkEntityName,
      submitFalg: false,
      company_dialog: this.company_dv,
      userLoginInfo: this.$store.getters.userLoginInfo,
      uniqueid: this.$store.getters.userLoginInfo.uniqueid, // 登录账号主键
      companyFormObj: {
        clientId: this.companyForm.clientId,
        firmName: this.companyForm.firmName, // 厂商名称
        firmPhone: this.companyForm.firmPhone, // 厂商联系手机号
        firmPerson: this.companyForm.firmPerson, // 厂商联系人
        firmOrgCode: this.companyForm.firmOrgCode, // 统一社会代码
        channelApp: this.companyForm.channelApp, // 产品形态APP
        channelSdk: this.companyForm.channelSdk, // 产品形态SDK
        firmEmail: this.companyForm.firmEmail,
        entityName:this.companyForm.entityName // 主体名称
      },
      rules: {
        firmName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          { max: 29, message: '不超过29位', trigger: 'blur' },
        ],
        firmPerson: [
          { required: true, message: '请输入企业联系人', trigger: 'blur' },
          { max: 10, message: '不超过10位', trigger: 'blur' },
        ],
        firmPhone: [
          {
            required: true,
            pattern: regular.mobile,
            message: '请输入正确的手机号码',
          },
        ],
        firmOrgCode: [
          {
            required: true,
            pattern: /^[0-9a-zA-Z]*$/g,
            message: '请输入正确的统一社会代码',
          },
        ],
      },
    };
  },
  created() {},
  methods: {
    async submitCompanyForm(formName) {
      const that = this;
      let apiName = 'saveTempForFirm';
      const formParams = JSON.parse(JSON.stringify(that.companyFormObj));
      if (that.titleType === 'update') {
        // 修改
        apiName = 'editTempForFirm';
        formParams.uniqueid = that.uniqueid;
        formParams.clientId = that.companyFormObj.clientId;
      } else if (that.envName === 'master') {
        // 集成环境下申请正式环境企业信息
        apiName = 'saveTempForFirm_master';
      } else {
        // 两个环境都没有的时候--添加集成环境企业信息
        apiName = 'saveTempForFirm_test';
        await that.$store.dispatch('loginStore/synLogin'); // 先同步执行集成会话
      }
      // eslint-disable-next-line consistent-return
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.toSaveTempForFirm(apiName, formParams);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    toSaveTempForFirm(apiName, formParams) {
      this.submitFalg = true;
      const that = this;
      that.$API[apiName](formParams)
        .then((result) => {
          this.submitFalg = false;
          if (!that.$API.ApiRequest(result)) {
            return;
          }
          if (that.titleType === 'new') {
            // 集成企业信息添加成功
            if (that.envName === 'test' && result.data.clientId) {
              // 把返回的集成环境ID存起来
              this.userLoginInfo.testClientId = result.data.clientId;
            } else if (result.data.clientId) {
              // 把返回的正式环境ID存起来
              this.userLoginInfo.clientId = result.data.clientId;
            }
            this.$store.dispatch('loginStore/changeSetting', {
              key: 'userLoginInfo',
              value: this.userLoginInfo,
            });
            that.toBindFirmToAccount(
              result.data.clientId,
              this.envType,
              result.data.checkCode,
            );
          } else {
            // 修改成功
            that.$emit('updateInfo');
            that.$API.SuccessBase('修改成功！');
          }
          that.$emit('cancelDialog', false);
        })
        .catch(() => {
          this.submitFalg = false;
        });
    },
    toBindFirmToAccount(clientid, type, checkCode) {
      const accountParam = {
        clientId: clientid,
        envType: type,
        checkCode,
      };
      this.$API.bindFirmToAccount(accountParam).then((result) => {
        if (!this.$API.ApiRequest(result)) {
          return;
        }
        this.$store.dispatch('loginStore/defaultEnv', this.envName);
      });
    },
    cancelDialog() {
      this.company_dialog = false;
      this.$emit('cancelDialog', this.company_dialog);
    },
    change() {
      this.$forceUpdate();
    },
  },
};
